var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgP2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 585,
    height: 157,
    viewBox: "0 0 585 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_14_8",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 585,
    height: 157
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 585,
    height: 157,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_14_8)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 294,
    y: 156,
    width: 458,
    height: 217,
    transform: "rotate(-166 294 156)",
    fill: "#61A9BF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 343.009,
    y: -103.408,
    width: 366.433,
    height: 112.806,
    transform: "rotate(158 343.009 -103.408)",
    fill: "#A2D9D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M735.4 45.2L291.004 156L238.507 -54.554L682.903 -165.354L735.4 45.2Z",
    fill: "#6372A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 137,
    y: -9,
    width: 333,
    height: 228,
    transform: "rotate(-43 137 -9)",
    fill: "#89ABDE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 299,
    y: -3,
    width: 390,
    height: 130,
    transform: "rotate(164 299 -3)",
    fill: "#6372A7"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 654,
    y: 104.5,
    width: 390,
    height: 130,
    transform: "rotate(-164 654 104.5)",
    fill: "#A2D9D2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgP2);
export default __webpack_public_path__ + "static/media/Bg_P2.d7d8053d1f1bb40c38054f6a3fe6c644.svg";
export { ForwardRef as ReactComponent };